export const DEFAULT_PAGE_SIZE = 5;
export const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];